import { useEffect, useState } from "react";

/**
 * The current viewport width in CSS pixels, re-read on resize.
 *
 * Lifted verbatim from components/dashboard.js, which was the only file in the app with any
 * responsive logic. It returns a number rather than {isMobile, isTablet} on purpose: callers
 * compare against their own threshold, so adding a second consumer cannot quietly register a
 * second resize listener, and dashboard.js keeps the 900/1200 boundaries it was already tuned
 * to. Those numbers look high for "mobile" in the abstract but are where this app's layouts
 * actually break — the recurring unit is a 400px image beside a 432-540px card, which stops
 * fitting at ~952px.
 *
 * Almost nothing needs this. clamp(), min(), % and flexWrap are plain CSS values that work
 * inside an inline style object, so reach for those first; this is for the cases where the
 * markup itself has to change, not just its measurements.
 */
export default function useViewportWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return width;
}
